<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M18 5.61522L13.7574 9.85786L27.8995 24L13.7574 38.1421L18 42.3848L32.1421 28.2426L36.3848 24L32.1421 19.7574L18 5.61522Z" />
</svg>
